import { FiasFlatType, FiasRoomType } from '@skbkontur/react-ui-addons';
import { flatTypes, roomTypes } from '../FiasOverrider.constants';
const getName = ({ flatNumber = '', flatType, roomNumber = '', roomType }) => {
    const nameWithFlat = flatType ? `${flatTypes[flatType]} ${flatNumber}`.trim() : flatNumber;
    const nameWithRoom = roomType ? `${roomTypes[roomType]} ${roomNumber}`.trim() : roomNumber;
    return nameWithRoom ? `${nameWithFlat}, ${nameWithRoom}` : nameWithFlat;
};
const ucFirst = (str) => {
    return !str ? str : str[0].toUpperCase() + str.slice(1);
};
const getValueFromObjectByKey = (candidate, searchValue) => {
    return Object.entries(candidate).find(([key]) => searchValue === key)?.[1] ?? null;
};
export const convertFlatToFiasRoom = (flat, room) => {
    if (!flat) {
        return;
    }
    const roomType = getValueFromObjectByKey(FiasRoomType, ucFirst(room?.type || '')) ?? FiasRoomType.None;
    const flatType = getValueFromObjectByKey(FiasFlatType, ucFirst(flat?.type || '')) ?? FiasFlatType.None;
    if (flat?.fiasId && room?.fiasId) {
        return {
            name: flat?.number || '',
            text: '',
            data: {
                id: '',
                flatType,
                roomType,
                fiasId: room.fiasId,
                flatFiasId: flat.fiasId,
                flatNumber: flat?.number || '',
                roomNumber: room?.number || undefined,
            },
        };
    }
    if (!room?.fiasId && flat.fiasId) {
        return {
            name: flat?.number || '',
            text: '',
            data: {
                id: '',
                flatType,
                fiasId: flat.fiasId,
                flatNumber: flat?.number || '',
            },
        };
    }
    return {
        name: getName({
            flatType,
            roomType,
            flatNumber: flat?.number || undefined,
            roomNumber: room?.number,
        }),
        text: '',
    };
};
